import FILTERED_TYPE, {
  FILTERED_COLUMNS_KEY,
  FILTERED_COLUMNS_OUTPUT_KEY
} from './constant'
import { find, isEmpty, isUndefined, filter, findIndex } from 'lodash'

export const updateUserFilteredColumns = (
  {
    tabular,
    activeFilter,
    // identifier,
    model,
    userId,
    nameFilter,
    type,
    kind,
    updateUserDataPreferences,
    id
  },
  userPreferences
) => {
  if (isUndefined(id)) return

  const localStorageFilteredColumns = getStoreObject(
    type,
    kind,
    userPreferences
  )
  const storedObjectByUser = getUserFilteredColumnsStorageByUser(
    {
      id,
      userId,
      type,
      kind
    },
    userPreferences
  )
  const filterAlreadyExist = !isEmpty(storedObjectByUser)

  const getNewObjectToStorage = () => {
    if (filterAlreadyExist) {
      const index = findIndex(
        storedObjectByUser,
        (el) => el?.name === nameFilter
      )
      if (index === -1) {
        return [
          ...storedObjectByUser /* [identifier] */,
          {
            name: nameFilter,
            model,
            selected: false,
            ...(type === FILTERED_TYPE.PIVOT && {
              // only for pivot
              tabular: tabular,
              filter: activeFilter
            })
          }
        ]
      } else {
        storedObjectByUser[index] = {
          name: nameFilter,
          model,
          selected: false,
          ...(type === FILTERED_TYPE.PIVOT && {
            // only for pivot
            tabular: tabular,
            filter: activeFilter
          })
        }
        return storedObjectByUser
      }
    } else
      return [
        {
          name: nameFilter,
          model,
          selected: false,
          ...(type === FILTERED_TYPE.PIVOT && {
            // only for pivot
            tabular: tabular,
            filter: activeFilter
          })
        }
      ]
  }

  const objectToSave = isEmpty(localStorageFilteredColumns)
    ? {
        [id]: getNewObjectToStorage()
      }
    : {
        ...localStorageFilteredColumns,
        [id]: getNewObjectToStorage()
      }

  updateStoreObject({
    sendUpdateToServer: true,
    kind,
    type,
    objectToSave,
    updateUserDataPreferences,
    userPreferences,
    userId,
    id
  })
}

export const getUserFilteredColumnsStorageByUser = (
  { id, type, kind },
  userPreferences
) => {
  const lockedColumnsStorage = getStoreObject(type, kind, userPreferences)
  return lockedColumnsStorage[id] || []
}

const getStoreObject = (type, kind, userPreferences) => {
  const userPref = userPreferences?.[kind] || {}

  // return JSON.parse(localStorage.getItem()) || {}
  return userPref?.[getKeyByType(type)] || {}
}

const updateStoreObject = ({
  sendUpdateToServer,
  type,
  objectToSave,
  updateUserDataPreferences,
  kind,
  userPreferences: userPref,
  userId
}) => {
  const config = {
    [kind]: { ...userPref?.[kind], [getKeyByType(type)]: objectToSave }
  }

  updateUserDataPreferences({
    sendUpdateToServer,
    userId,
    config
  })

  // eslint-disable-next-line no-undef
  // localStorage.setItem(getKeyByType(type), JSON.stringify(objectToSave))
}

const getKeyByType = (type) => {
  // INPUTVIEW OR OUTPUT
  return type === FILTERED_TYPE.TABLE
    ? FILTERED_COLUMNS_KEY
    : FILTERED_COLUMNS_OUTPUT_KEY
}

export const isNameAlreadyStored = ({
  filterName,
  type,
  // identifier,
  userId,
  kind,
  userPreferences,
  id
}) => {
  const storedObjectByUser = getUserFilteredColumnsStorageByUser(
    {
      id,
      type,
      kind
    },
    userPreferences()
  )
  const wtAlreadyExist = !isEmpty(storedObjectByUser) // keys(storedObjectByUser).includes(identifier)

  if (!wtAlreadyExist) {
    // object does not already exist
    return false
  } else {
    const findObj = find(storedObjectByUser, {
      name: filterName
    })
    return !isUndefined(findObj)
  }
}

export const removeFromStoreByName = (
  {
    id,
    filterName,
    type,
    /* identifier,  */ userId,
    kind,
    updateUserDataPreferences
  },
  userPreferences
) => {
  const storedObjectByUser = getUserFilteredColumnsStorageByUser(
    {
      id,
      userId,
      type,
      kind
    },
    userPreferences
  )

  if (storedObjectByUser && !isEmpty(storedObjectByUser)) {
    const filteredObject = filter(
      storedObjectByUser,
      ({ name }) => name !== filterName
    )

    const storedFilteredColumns = getStoreObject(type, kind, userPreferences)

    const objectToSave = {
      ...storedFilteredColumns,

      [id]: filteredObject
    }

    if (isEmpty(filteredObject)) {
      delete objectToSave[id]
    }

    updateStoreObject({
      sendUpdateToServer: true,
      userPreferences,
      kind,
      type,
      objectToSave,
      updateUserDataPreferences,
      userId
    })
    return true
  }
  return false
}

export const getDefaultFilter = (
  { userId, /* identifier,  */ type, kind, id },
  userPreferences
) => {
  const storedObjectByUser = getUserFilteredColumnsStorageByUser(
    {
      id,
      userId,
      type,
      kind
    },
    userPreferences
  )
  const filters = storedObjectByUser
  if (isEmpty(filters)) return { id: 'none', model: {} }
  const selectedObj = filters.find(({ selected }) => selected)
  if (isEmpty(selectedObj)) return { id: 'none', model: {} }
  return selectedObj
}

export const saveSelectedFilter = (
  {
    selectedFilter,
    userId,
    // identifier,
    type,
    kind,
    updateUserDataPreferences,
    id
  },
  userPreferences
) => {
  const storedObjectByUser = getUserFilteredColumnsStorageByUser(
    {
      id,
      userId,
      type,
      kind
    },
    userPreferences
  )
  if (!storedObjectByUser || isEmpty(storedObjectByUser)) return
  const filters = storedObjectByUser /* [identifier] */
  const newFilters = filters.map((filter) => ({
    ...filter,
    selected: filter.name === selectedFilter
  }))

  const filteredColumnsStored = getStoreObject(type, kind, userPreferences)

  const objectToSave = {
    ...filteredColumnsStored,
    [id]: newFilters
  }
  updateStoreObject({
    sendUpdateToServer: false,
    userPreferences,
    kind,
    type,
    objectToSave,
    updateUserDataPreferences,
    userId
  })
}
